import React, { useEffect } from 'react';

import { observer } from 'mobx-react';

import { InfoBox, LbPagination } from '@infoods/lifebase-ui';
import classes from './PaymentHistoryTable.module.scss';

import { EmptyList } from '../../../../shared/components/ui-components';
import { HeaderRow } from './HeaderRow/HeaderRow';
import { scanIqPaymentHistoryStore } from '../../../stores/scanIqPaymentHistoryStore';
import { HistoryItemRow } from './HistoryItemRow/HistoryItemRow';

type PaymentHistoryTableProps = {
  entityId: number;
  customerId: number;
};

const PaymentHistoryTable = observer(
  ({ entityId, customerId }: PaymentHistoryTableProps) => {
    const { historyRecords, filterMethods, getPaymentHistory, setDefaultValues } =
      scanIqPaymentHistoryStore;

    const { elementsPerPage, totalElements, getPaginationProps, isShowPlaceholder } =
      filterMethods;

    useEffect(() => {
      getPaymentHistory(entityId, customerId);

      return () => {
        setDefaultValues();
      };
    }, []);

    return (
      <InfoBox title="Payment History" customContentPadding>
        <div className={classes.paymentHistoryTable}>
          <HeaderRow />
          {historyRecords.map((historyRecord) => (
            <HistoryItemRow key={historyRecord.id} historyRecord={historyRecord} />
          ))}
          <EmptyList show={isShowPlaceholder} description="There are no invoices" />
        </div>
        <LbPagination
          {...getPaginationProps()}
          elementsPerPage={elementsPerPage}
          totalElements={totalElements}
          variant="inBox"
        />
      </InfoBox>
    );
  },
);

export { PaymentHistoryTable };
